module.exports = __webpack_public_path__ + "img/checkedItem.232f7737.svg";